import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl"

//Import Components
import MiniWidgets from "./MiniWidgets";
import RevenueAnalytics from "./RevenueAnalytics";
import SalesAnalytics from "./SalesAnalytics";
import Calculator from "./Calculator";


class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.obj = JSON.parse(localStorage.getItem("authUser"))
        if (!this.obj){
            this.props.history.push('/logout')}
        this.state = {
 
            breadcrumbItems : [],
            reports : [],
            data:[],
            
        }
        this.LoadUserData = this.LoadUserData.bind(this)
    }
    componentDidCatch(error) {
        // Changing the state to true
        // if some error occurs
        console.log(error)
      }
    async componentDidMount() {
        if (!JSON.parse(localStorage.getItem("user_permission"))){

            this.LoadUserData()
        }
        document.title = "Dashboard | Planmans"
 
        const requestOptions = {
               method: 'GET',
               headers: { 'Content-Type': 'application/json' },
           };
           await fetch(`${BaseUrl}/api/itineraries/dashboard/`,requestOptions)
               .then(res => res.json())
               .then(
                   (data) => {

                       let reports = [
                        { icon : "ri-book-mark-fill", title : "All Itineraries", value : data.itinerraries , rate : data.itinerraries, desc : "From previous period" }, 
                        { icon : "ri-bookmark-3-fill", title : "Processing", value : data.processing , rate : data.processing, desc : "From previous period" },
                        { icon : "ri-kakao-talk-line", title : "Under Discussion", value : data.discussion, rate : data.discussion, desc : "From previous period" },
                        { icon : "ri-exchange-dollar-fill", title : "Tour Booked", value : data.booked, rate : data.booked, desc : "From previous period" },
                        { icon : "ri-bar-chart-box-fill", title : "Tour in Progress", value : data.progress, rate :data.progress, desc : "From previous period" },
                        { icon : "ri-briefcase-4-line", title : "Tour Completed", value : data.completed, rate : data.completed, desc : "From previous period" },
                        ]

                   this.setState({ reports:reports, data:data })
                   },
                   (error) => {
                       console.log(error, 'error--------------') 
                   }
               )  
     }

     async LoadUserData(){
        if (!this.obj.user.is_superuser){

            const requestOptions = {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' },
            };
        
            await fetch(`${BaseUrl}/api/accounts/users/${this.obj.user.id}/`,requestOptions)
                .then(res => res.json())
                .then(
                    (data) => {
                        console.log(data)
                        let user_role = data.group?.role
                        let old_perm = this.obj.user.group?.role
                        let match = true
                        if (user_role && old_perm){
                            if(old_perm.length === user_role.length){
                                for(let i=0; i<user_role.length; i++){
                                    if(user_role[i].name !== old_perm[i].name){
                                        match = false
                                        break
                                    }
                                }
                                if(!match){
                                    this.props.history.push('/logout')
                                }

                            }
                        }
                        localStorage.setItem("user_permission", JSON.stringify(true)); 


                    },
                    (error) => {
                        console.log(error, 'error-------------')
                        
                    }
                ) 
        }
    
      }

    render() {
        const {reports } = this.state
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="Dashboard" breadcrumbItems={[]} />
                    <Row>
                    <Calculator />
                    </Row>
                        <Row>
                            <Col xl={12}>
                                <Row>
                                    <MiniWidgets reports={reports} />
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl={6}>
                            <RevenueAnalytics/>
                            </Col>

                            <Col xl={6}>
                              
                                <SalesAnalytics 
                                data = {this.state.data}/>

                                {/* <Calculator /> */}
                                
                            </Col>
                        
                        </Row>
            

                    </Container> 
                </div>
            </React.Fragment>
        );
    }
}

export default Dashboard;
